import {h, Fragment} from "preact"
import { usePagination, useActions } from "@nosto/preact"
import { IconChevronLeft, IconChevronRight } from "../icons"

function PageLink({ onClick, href, className, ariaLabel, title, ariaHidden, disabled, children }) {
    return (
        <a
            className={`${className} ${disabled && 'disabled'}`}
            href={disabled ? '#' : href}
            {...(ariaLabel ? {ariaLabel} : null)}
            {...(title ? {title} : null)}
            ariaHidden={ariaHidden}
            onClick={onClick}
        >
            {children}
        </a>
    )
}

const NavItem = ({ page, pageLinkProps }) => {
    return (
        page.current ? 
            <>
                <span className="visually-hidden">{`Current page: ${page.page}`}</span>
                <span className="a active" ariaHidden="true">{page.page}</span>
            </>
        : 
            <PageLink {...pageLinkProps} className="a">
                <span className="visually-hidden">{`Page ${page.page}`}</span>
                <span ariaHidden="true">{page.page}</span>
            </PageLink>
    )
}

const ArrowItem = ({ type, status, pageLinkProps }) => {
    return (
        <PageLink {...pageLinkProps} className={type} title={type == 'prev' ? 'Previous' : 'Next'} disabled={status}>
            {type == 'prev' ? <IconChevronLeft /> : <IconChevronRight />}
        </PageLink>
    )
}

const AggregatorItem = ({ type, pageLinkProps, page }) => {
    return (
        <>
            {type == 'last' && <span>...</span>}
            <PageLink {...pageLinkProps} className="a">
                {page.page}
            </PageLink>
            {type == 'first' && <span>...</span>}
        </>
    )   
}

export default function Pagination() {
    const { prev, first, pages, last, next, current } = usePagination({
        width: 5
    })
    const { updateSearch, simulateUpdateSearch } = useActions()

    function pageLinkProps({ from }) {
        return {
            onClick: e => {
                e.preventDefault()
                updateSearch({ products: { from } })
                // scrollTo(0, 0)
            },
            href: simulateUpdateSearch({ products: { from } }).url
        }
    }

    return (
        <div className="pagination nosto-pagination">
            <div className="flex flex-wrap align-items-center justify-content-center">
                
                <ArrowItem pageLinkProps={{...(prev ? pageLinkProps(prev) : { from: 0 })}} type="prev" status={!!prev} />

                {first && <AggregatorItem type="first" page={first} pageLinkProps={{...pageLinkProps(first)}} />}

                <nav className="pages flex flex-wrap align-items-center justify-content-center">
                    {pages.map(page => <NavItem page={page} pageLinkProps={{...pageLinkProps(page)}} />)}
                </nav>

                {last && <AggregatorItem type="last" page={last} pageLinkProps={{...pageLinkProps(last)}} />}

                <ArrowItem pageLinkProps={{...(next ? pageLinkProps(next) : { from: 0 })}} type="next" status={!!next} />
                
            </div>
        </div>
    )
}
